import React from "react";
import { Box } from "@mui/material";

export default function TrendChartMUI({ value, trend, color, size = 60 }) {
  const points = React.useMemo(() => {
    const basePoints = [
      [10, 40],
      [20, 35],
      [30, 30],
      [40, 25],
      [50, 30],
    ];

    if (trend === "up") {
      return [...basePoints, [60, 20], [70, 15], [80, 10]];
    } else if (trend === "down") {
      return [...basePoints, [60, 35], [70, 40], [80, 45]];
    } else {
      return [...basePoints, [60, 30], [70, 28], [80, 30]];
    }
  }, [trend]);

  const pathData = points
    .map((point, index) => `${index === 0 ? "M" : "L"} ${point[0]} ${point[1]}`)
    .join(" ");

  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <svg width={size} height={size} viewBox="0 0 90 50">
        <path
          d={pathData}
          stroke={color}
          strokeWidth="2"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {points.map((point, index) => (
          <circle
            key={index}
            cx={point[0]}
            cy={point[1]}
            r="1.5"
            fill={color}
          />
        ))}
      </svg>
    </Box>
  );
}
